module.exports = __webpack_public_path__ + "media/img/alufelgi@2x-232e66f0.png";